import React from 'react';
import { useNavigate } from 'react-router-dom';
import { companyInfo } from '../styles/variables';

const Footer = () => {
  const navigate = useNavigate();
  const year = new Date().getFullYear();

  const scrollTo = (id) => {
    navigate('/');
    setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }, 300);
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-inner">
          <div className="footer-logo">
            <span>Swiss N Scott</span>
          </div>

          <div className="footer-links">
            <a className="footer-link" onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>Home</a>
            <a className="footer-link" onClick={() => scrollTo('categories')} style={{ cursor: 'pointer' }}>Categories</a>
            <a className="footer-link" onClick={() => scrollTo('about')} style={{ cursor: 'pointer' }}>About</a>
            <a className="footer-link" onClick={() => scrollTo('contact')} style={{ cursor: 'pointer' }}>Contact</a>
          </div>

          <div className="footer-copy">
            © {year} Swiss N Scott · Multan, Pakistan · {companyInfo.certifications.join(' · ')}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
